import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

export default class PatientDetail extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired
  };

  render() {
    const { cardNumber, fullName } = this.props;

    return (
      <>
        <Text style={styles.fullName}>{fullName}</Text>
        {/* <Text style={styles.cardNumber}>{cardNumber}</Text> */}
      </>
    );
  }
}

const styles = StyleSheet.create({
  cardNumber: {
    color: staticColors.white,
    fontSize: 16,

    ...fonts.light
  },
  fullName: {
    color: staticColors.white,
    fontSize: 20,

    ...fonts.regular
  }
});
